import {
    BOOK_APPOINMENT_QUESTIONARE,
    STORE_APPOINMENT_FORM_DATA,
    ADD_FAMILY,
    EDIT_FAMILY,
    BOOKING_CONFIRMATION,
    BOOKING_UPDATE_CONFIRMATION,
    REQUEST_BOOKING_CONFIRM,
    RESET_BOOKING,
    GOTO_DASHBOARD,
    UPDATE_UPLOADED_FILES,
    FETCH_PATIENT_MEDICAL_DATA
  } from "./type";
  import loginedApi from "../apis";
  import axios from "axios";
  import { toast } from "react-toastify";
  import { useSelector } from "react-redux";
  import CryptoJS from "crypto-js";
    var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);
  
  const publicIp = require("public-ip");
  let IP = publicIp.v4();
  const { detect } = require('detect-browser');
  const browser = detect();
  
  let platform = window.navigator.platform;
  let userAgent = window.navigator.userAgent;
  let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
  let formatTime = off?.split("GMT")[1].split(" (")[0];
  let result = formatTime?.slice(1);
  if (formatTime.search(/\+/g) != null) {
    formatTime = formatTime.replace(/\+/g, "%2B")
  } else if (formatTime.search(/\-/g) != null) {
    formatTime = formatTime.replace(/\-/g, "%2D")
  }//replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`
  
  export const fetch_appoinment_questions = () => async (dispatch) => {
    const res = await axios.post(
      "https://run.mocky.io/v3/bb5a24bf-255b-4289-9432-7ff1ebee4320"
    );
  
    dispatch({ type: BOOK_APPOINMENT_QUESTIONARE, payload: res.data });
  };
  
  export const Store_formData = (data) => async (dispatch) => {
    dispatch({ type: STORE_APPOINMENT_FORM_DATA, payload: data });
  };
  
  export const book_slot =
    ({ data, userr, old_appointment, setPaymentLoading }) =>
      async (dispatch) => {
  
        
        let data1 = {
          nationalId: data.nationalId,
  
          // insurance: {
          //   provider: data.insurance.provider,
          //   membershipNo: data.insurance.membershipNo,
          // },
          symptoms: data.symptoms,
          medicalcondition: data.medicalConditions,
          patientHeight: "",
          firstName: data.firstName,
          reasonForVisit: "Others",
          notesToDoctor: data.complaint,
          weightMeasurement: "",
          noOfBooking: 1,
          bookingFrom: data.bookingFrom,
          reminderNumber: data.reminderNumber,
          alternativeNumber:data.alternativeNumber,
          appointmentFor: data.appointmentFor,
          reports: data.reports,
          blockId: "",
          selectedReportsValues:data.selectedReportsValues,
          basicFees: data.fees.split(" ")[1],
          surgerydetails: data.surgeries,
          referenceId: data.referenceId,
          allergies: data.allergies,
          gender: data.gender,
          address: data.address,
          appointmentDate: data.appointmentDate,
          emergencyname: data.emergencyname,
          relationship: data.relationship,
          patientWeight: "",
          dob: data.dob,
          heightMeasurement: "",
          medications: data.medications,
          emergencyrelation: data.emergencyrelation,
          dentalInfo: "[]",
          bookingType: data.bookingType,
          fees: data.fees,
          hospitalid: data.hospitalid,
          typeofconsultation: "",
          doctorId: data.doctorId,
          emergencyphone: data.emergencyphone,
          status: data.status,
          modeOfConsultation: "Video",
          duration: data.duration,
          appointmentTime: data.appointmentTime,
          lastName: "",
          typeofconsultation: data.typeofconsultation,
        };
  
  
        let response = [];
        let orderRes = [];
  
        console.log("------data", data)










//gangagenrtorderid
    response = await loginedApi.post("/gangagenrtorderid", {
    token :hashcode.toString(),
     data: {
       IsfromMobile: true,
       bookingFrom: data.bookingFrom,
       todayRate: "74.27006",
       Ipaddress: IP,
       Os: platform,
       browserTimeZone: `GMT${formatTime}`,
       attachedReportFiles: "[]",
       doctorId: data.doctorId,
       fees: data.fees,
       appointmentId: data.referenceId,
       patientId: userr.userId,
       appointmentDetails: data1,
       actualRate: "74.27006",
       useragent: userAgent,
       Browser: browser.name + " " + browser.version,
       appname: "C2MD Web",
     },
     requestType: "1028",
   });
   orderRes = response.data.data;
   data1.bookingFrom = "Book";
   data1.referenceId = orderRes.info;

   console.log(orderRes)
   


        // let orderRes = response.data.data;
  
        if (data1?.bookingFrom == "Request") {
          if(orderRes.info.includes("You can"))
          {
            return orderRes.info;
          }else
          {
            localStorage.setItem("RequestId",orderRes.info)
            let appinmentData = {
              appoinmentId: orderRes.info,
              appoinmentFromTime: "",
              appoinmentToTime: "",
              appoinmentType: "Request",
            };
            dispatch({ type: BOOKING_CONFIRMATION, payload: "Request" });
          }
          // dispatch({ type: REQUEST_BOOKING_CONFIRM });
  
          // dispatch(
          //   BookingConfirmationOnRequest({
          //     orderData: data1,
          //     user: userr,
          //     orderRes,
          //   })
          // );
        } else {
  
  
          dispatch(
            displayRazorpay({
              setPaymentLoading,
              orderRes,
              orderdata: data1,
              user: userr,
              formData: data,
            })
          );
        }
      };
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }
  
  export const displayRazorpay =
    ({ orderRes, orderdata, user, formData, setPaymentLoading }) =>
      async (dispatch) => {
        const res = await loadScript(
          "https://checkout.razorpay.com/v1/checkout.js"
        );
  
        if (!res) {
          alert("Razorpay SDK failed to load. Are you online?");
          return;
        }

        console.log("orderdata",orderdata)
  
        let result = {
          amount: orderdata.basicFees * 100,
          currency: "INR",
          receipt: "Receipt no. 1",
          payment_capture: 1,
          notes: {
            notes_key_1: "Tea, Earl Grey, Hot",
            notes_key_2: "Tea, Earl Grey… decaf.",
          },
          order_id: orderRes?.id,
        };
  
        const { amount, order_id, currency } = result;
  
        const options = {
          key: orderRes.APIKey, // Enter the Key ID generated from the Dashboard
          amount: amount.toString(),
          currency: currency,
          //name: formData?.hospitalname!=""?formData?.hospitalname:"https://www.gangahospital.com/public/images/logo/logo_new1.jpg",
          name :"Ganga Hospital",
          description: "TM-"+Date.now(),
          //image: formData?.clinicLogo,
          image:"https://www.gangahospital.com/public/images/logo/logo_new1.jpg",
          order_id: order_id,
          
          handler: async function (response) {
            const data = {
              orderCreationId: order_id,
              razorpayPaymentId: response.razorpay_payment_id,
              razorpayOrderId: response.razorpay_order_id,
              razorpaySignature: response.razorpay_signature,
            };

            console.log("response",response)
  
             dispatch(
              signature_Verification({
                razorpayRes: data,
                orderData: orderdata,
                user: user,
                orderRes: orderRes,
              })
            ); 
          },
          "modal": {
            "ondismiss": function () {
              setPaymentLoading(false)
              console.log('Checkout form closed');
            }
          },
          prefill: {
            name: "",
            email: user.userName,
            contact: user.mobileNumber,
          },
          notes: {
            //address: "Example Corporate Office",
            merchant_order_id: "TM-"+Date.now(),
          },
          theme: {
            color: "#61dafb",
          },
        };
  
        const paymentObject = new window.Razorpay(options);
        paymentObject.on("payment.failed", function (response) { });
        paymentObject.open();
      };
  
  export const signature_Verification =
    ({ razorpayRes, orderData, user, orderRes }) =>
      async (dispatch) => {

        console.log("signature_Verification",razorpayRes, orderData, user, orderRes)
        let uploadData = {
          transactionPG: "RAZORPAY",
          userId: user.userId,
          appointmentDetails: {
            appointmentBook: {
              patientHeight: "0",
              firstName: orderData.firstName,
              reasonForVisit: orderData.reasonForVisit,
              notesToDoctor: orderData.notesToDoctor,
              weightMeasurement: "-",
              noOfBooking: 1,
              bookingFrom: orderData.bookingFrom,
              alternativeNumber:orderData.alternativeNumber,
              reminderNumber: orderData.reminderNumber,
              appointmentFor: orderData.appointmentFor,
              reports: orderData.reports,
              blockId: orderRes?.info,
              basicFees: orderData.basicFees,
  
              referenceId: orderData.referenceId,
              surgerydetails: orderData.surgerydetails,
              allergies: orderData.allergies,
              symptoms: orderData.symptoms,
              medicalConditions: orderData.medicalConditions,
              medications: orderData.medications,
              gender: orderData.gender,
              address: orderData.address,
              appointmentDate: orderData.appointmentDate,
              emergencyname: orderData.emergencyname,
              relationship: orderData.relationship,
              patientWeight: "0",
              dob: orderData.dob,
              heightMeasurement: "-",
              selectedReportsValues:orderData.selectedReportsValues,
  
              emergencyrelation: orderData.emergencyrelation,
              dentalInfo: "[]",
              bookingType: orderData.bookingType,
              fees: orderData.fees,
              hospitalid: orderData.hospitalid,
              typeofconsultation: orderData.typeofconsultation,
              doctorId: orderData.doctorId,
              emergencyphone: orderData.emergencyphone,
              status: orderData.status,
              modeOfConsultation: "Video",
              duration: orderData.duration,
              appointmentTime: orderData.appointmentTime,
              lastName: "",
            },
            couponCode: "",
            bookingId: "",
          },
          actualRate: "74.27006",
          couponCode: "",
          Ipaddress: IP,
          transactionId: razorpayRes.razorpayPaymentId,
          blockId: "",
          browserTimeZone: `GMT${formatTime}`,
          attachedReportFiles: "[]",
          Os: platform,
          useragent: userAgent,
          razorpayId: razorpayRes.razorpayPaymentId,
          patientId: user.userId,
          referenceId: "",
          todayRate: "74.27006",
          bookingFrom: orderData.bookingFrom,
          Browser: browser.name + " " + browser.version,
          appname: "C2MD Web",
        };
        const res = await loginedApi.post("paymentwithsignature", {
          data: {
            razorpay_signature: razorpayRes.razorpaySignature,
            useragent: userAgent,
            razorpay_order_id: razorpayRes.razorpayOrderId,
            razorpayId: razorpayRes.razorpayPaymentId,
            Ipaddress: IP,
            appointmentBook :uploadData,
            Os: platform,
            Browser: browser.name + " " + browser.version,
            appname: "C2MD Web",
          },
         token :hashcode.toString(),
          requestType: "1025",
        });
  
        console.log("response",res)
        let response = res.data.data;
        let timeData = localStorage.getItem("appinmentTime");
        let appinmentTime = JSON.parse(timeData);
        let appinmentData = {
          appoinmentId: response,
          appoinmentFromTime: appinmentTime?.appoinmentFromTime,
          appoinmentToTime: appinmentTime?.appoinmentToTime,
          appoinmentType: "Book",
        };
        if (response?.info !== "Failed") {
          dispatch({ type: BOOKING_CONFIRMATION, payload: appinmentData });
          localStorage.removeItem("appinmentTime");
        } else {
        }
        /* if (res.data?.data.status === "Success") {
          dispatch(
            BookingConfirmation({
              razorpayRes: razorpayRes,
              orderData: orderData,
              user: user,
              orderRes: orderRes,
            })
          );
        } */
      };
  export const BookingConfirmation =
    ({ razorpayRes, orderData, user, orderRes }) =>
      async (dispatch) => {
        let uploadData = {
          transactionPG: "RAZORPAY",
          userId: user.userId,
          appointmentDetails: {
            appointmentBook: {
              patientHeight: "0",
              firstName: orderData.firstName,
              reasonForVisit: orderData.reasonForVisit,
              notesToDoctor: orderData.notesToDoctor,
              weightMeasurement: "-",
              noOfBooking: 1,
              bookingFrom: orderData.bookingFrom,
              reminderNumber: orderData.reminderNumber,
              appointmentFor: orderData.appointmentFor,
              reports: orderData.reports,
              blockId: orderRes?.info,
              basicFees: orderData.basicFees,
  
              referenceId: orderData.referenceId,
              surgerydetails: orderData.surgerydetails,
              allergies: orderData.allergies,
              symptoms: orderData.symptoms,
              medicalConditions: orderData.medicalConditions,
              medications: orderData.medications,
              gender: orderData.gender,
              appointmentDate: orderData.appointmentDate,
              emergencyname: orderData.emergencyname,
              relationship: orderData.relationship,
              patientWeight: "0",
              dob: orderData.dob,
              heightMeasurement: "-",
              alternativeNumber:orderData.alternativeNumber,
              emergencyrelation: orderData.emergencyrelation,
              dentalInfo: "[]",
              bookingType: orderData.bookingType,
              fees: orderData.fees,
              hospitalid: orderData.hospitalid,
              typeofconsultation: orderData.typeofconsultation,
              doctorId: orderData.doctorId,
              emergencyphone: orderData.emergencyphone,
              status: orderData.status,
              modeOfConsultation: "Video",
              duration: orderData.duration,
              appointmentTime: orderData.appointmentTime,
              lastName: "",
            },
            couponCode: "",
            bookingId: orderRes?.info,
          },
          actualRate: "74.27006",
          couponCode: "",
          Ipaddress: IP,
          transactionId: razorpayRes.razorpayPaymentId,
          blockId: orderRes?.info,
          browserTimeZone: `GMT${formatTime}`,
          attachedReportFiles: "[]",
          Os: platform,
          useragent: userAgent,
          razorpayId: razorpayRes.razorpayPaymentId,
          patientId: user.userId,
          referenceId: "",
          todayRate: "74.27006",
          bookingFrom: orderData.bookingFrom,
          Browser: browser.name + " " + browser.version,
          appname: "C2MD Web",
        };
  
        const res = await loginedApi.post("payment", {
          data: uploadData,
         token :hashcode.toString(),
          requestType: "313",
        });
  
        let response = res.data.data;
        let timeData = localStorage.getItem("appinmentTime");
        let appinmentTime = JSON.parse(timeData);
        let appinmentData = {
          appoinmentId: response,
          appoinmentFromTime: appinmentTime?.appoinmentFromTime,
          appoinmentToTime: appinmentTime?.appoinmentToTime,
          appoinmentType: "Book",
        };
        if (response?.info !== "Failed") {
          dispatch({ type: BOOKING_CONFIRMATION, payload: appinmentData });
          localStorage.removeItem("appinmentTime");
        } else {
        }
      };
  
  //
  export const addMember = (member) => async (dispatch) => {
    dispatch({ type: ADD_FAMILY, payload: member });
  };
  
  export const editMember = (member) => async (dispatch) => {
    dispatch({ type: EDIT_FAMILY, payload: member });
  };
  export const BookingConfirmationOnRequest =
    ({ orderData, user, orderRes }) =>
      async (dispatch) => {
        let uploadData = {
          transactionPG: "RAZORPAY",
          userId: user.userId,
          appointmentDetails: {
            appointmentBook: {
              patientHeight: "100",
              firstName: orderData.firstName,
              reasonForVisit: orderData.reasonForVisit,
              notesToDoctor: orderData.notesToDoctor,
              weightMeasurement: "kg",
              noOfBooking: 1,
              bookingFrom: orderData.bookingFrom,
              reminderNumber: "",
              appointmentFor: orderData.appointmentFor,
              reports: orderData.reports,
              blockId: orderRes?.info,
              basicFees: orderData.basicFees,
              surgerydetails: orderData.surgeries,
              referenceId: "",
              allergies: orderData.allergies,
              gender: orderData.gender,
              appointmentDate: orderData.appointmentDate,
              emergencyname: orderData.emergencyname,
              relationship: orderData.relationship,
              patientWeight: "200",
              dob: orderData.dob,
              heightMeasurement: "cm",
              medications: orderData.medications,
              emergencyrelation: orderData.emergencyrelation,
              dentalInfo: "[]",
              bookingType: orderData.bookingType,
              fees: orderData.fees,
              hospitalid: "",
              typeofconsultation: orderData.typeofconsultation,
              doctorId: orderData.doctorId,
              emergencyphone: "",
              status: orderData.status,
              modeOfConsultation: "Video",
              duration: orderData.duration,
              appointmentTime: orderData.appointmentTime,
              lastName: "",
            },
            couponCode: "",
            bookingId: orderRes?.info,
          },
          actualRate: "74.27006",
          couponCode: "",
          Ipaddress: IP,
          transactionId: "",
          blockId: orderRes?.info,
          browserTimeZone: `GMT${formatTime}`,
          attachedReportFiles: "[]",
          Os: platform,
          useragent: userAgent,
          razorpayId: "",
          patientId: user.userId,
          referenceId: "",
          todayRate: "74.27006",
          bookingFrom: orderData.bookingFrom,
          Browser: browser.name + " " + browser.version,
          appname: "C2MD Web",
        };
  
        const res = await loginedApi.post("payment", {
          data: uploadData,
         token :hashcode.toString(),
          requestType: "313",
        });
  
        let response = res.data.data;
  
        if (response?.info !== "Failed") {
          dispatch({ type: BOOKING_CONFIRMATION, payload: response });
        } else {
        }
      };
  export const GotoDashboard_action = () => async (dispatch) => {
    dispatch({ type: GOTO_DASHBOARD });
  };
  
  export const reset_booking = () => async (dispatch) => {
    dispatch({ type: RESET_BOOKING });
  };
  
  export const remove_uploaded_file_redux = ({ files, popFileUrl }) => async (dispatch) => {
  
  
    let filteredArray = files.filter((element) => element.fileurl != popFileUrl)
  
    console.log(filteredArray);
  
    dispatch({ type: UPDATE_UPLOADED_FILES, payload: filteredArray });
  
  
  };
  
  export const fetch_fees = (doctorId, MRNId) => async (dispatch) => {
    let countrycoderes = await loginedApi.post("getcountrycode",
      {
        token :hashcode.toString(),
        "version": "2.0",
        "data": { browserTimeZone: `GMT${formatTime}`, },
        "requestType": 1058
      });
  
    let doctorscountrycode = countrycoderes.data.data;
    let params = {
      requestType: "400",
     token :hashcode.toString(),
      data: {
        browserTimeZone: `GMT${formatTime}`,
        currency: doctorscountrycode.currency,
        accessCountry: doctorscountrycode.Country,
        Ipaddress: doctorscountrycode.Ipaddress,
        todayRate: "",
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        hospitalId: MRNId,
        specialityId: doctorId,
      },
    };
  
    console.log("Calling............................", params);
    const response = await loginedApi.post("getpatientfees", params);
   // dispatch({ type: FETCH_CONSULTATION, payload: response.data.data });
  
    return response.data.data;
  };


  //This API call is used to fetch the patient's profile details from DB
export const getpatienthelthdata = (patientId) => async (dispatch) => {
  console.log("Inside fetchlistofpatientsvitals")   
  let resp = await loginedApi.post("getcountrycode", 
  {
   token :hashcode.toString(),
    "version":"2.0",
    "data": {"browserTimeZone":"GMT%2B05:30"},
    "requestType": 1058
  });
  const countrycode = resp.data.data; 
  let data = { 
      Ipaddress : countrycode.Ipaddress,
      useragent : userAgent,
      Os : platform, 
      browserTimeZone : "GMT+05:30",
      patientId: patientId,
        
      
  }
  
 const response = await loginedApi.post("profile", {
    requestType : 68,
   token :hashcode.toString(),
    data
  }
    
  );
  
  console.log( "fetchlistofpatientsvitals API - Response!!!" ,response);
  dispatch({ type: FETCH_PATIENT_MEDICAL_DATA, payload: response.data.data });
  //  if (response.status === 200) {
  //    dispatch({ type: FETCH_PATIENTS_HEALTH_DATA, payload: response.data });
  //  }  
  return response.data.data
};


 //This API call is used to fetch the patient's profile details from DB
 export const updatepatientHealthInfo = (patientId,reqdata) => async (dispatch) => {
  console.log("Inside fetchlistofpatientsvitals")   
  let resp = await loginedApi.post("getcountrycode", 
  {
   token :hashcode.toString(),
    "version":"2.0",
    "data": {"browserTimeZone":"GMT%2B05:30"},
    "requestType": 1058
  });
  const countrycode = resp.data.data; 
  let data = { 
      Ipaddress : countrycode.Ipaddress,
      useragent : userAgent,
      Os : platform, 
      patientMedicalInfo:reqdata,
      browserTimeZone : "GMT+05:30",
      patientId: patientId,
        
      
  }
  
 const response = await loginedApi.post("updatepatienthealthinfo", {
    requestType : 70,
   token :hashcode.toString(),
    data
  }
    
  );
  
  console.log( "updatepatienthealthinfo API - Response!!!" ,response);
 // dispatch({ type: FETCH_PATIENT_MEDICAL_DATA, payload: response.data.data });
  //  if (response.status === 200) {
  //    dispatch({ type: FETCH_PATIENTS_HEALTH_DATA, payload: response.data });
  //  }  
  return response.data.data
};


//This API call is used to remove from Disk
export const removefile = (filename) => async (dispatch) => {
  
 const response = await loginedApi.post("removereports", {
   
   token :hashcode.toString(),
   requestType: 596,
   data: { filename: filename },
  }
    
  );
  
  console.log( "removereports API - Response!!!" ,response);
 // dispatch({ type: FETCH_PATIENT_MEDICAL_DATA, payload: response.data.data });
  //  if (response.status === 200) {
  //    dispatch({ type: FETCH_PATIENTS_HEALTH_DATA, payload: response.data });
  //  }  
  return response.data.data
};